var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27.83 29.07"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Download")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download_Base",
    "data-name": "Download/Base"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Clip-2",
    d: "M13.35,11.81v15l-4-4.06a.56.56,0,0,0-.81,0,.6.6,0,0,0,0,.83l5.33,5.46,5.34-5.46a.6.6,0,0,0,0-.83.56.56,0,0,0-.81,0l-4,4.06v-15a.57.57,0,1,0-1.13,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M12,3.41A7.58,7.58,0,0,1,18.25,0a7.71,7.71,0,0,1,7.61,7.8,8.27,8.27,0,0,1-.06,1,5.82,5.82,0,0,1,2,4.44A5.72,5.72,0,0,1,22.19,19H5.65A5.73,5.73,0,0,1,0,13.21a5.72,5.72,0,0,1,4.67-5.7,5.09,5.09,0,0,1,5-4.67A5,5,0,0,1,12,3.41Zm.65,1L12.33,5l-.49-.33A3.81,3.81,0,0,0,9.67,4,4,4,0,0,0,5.75,8V8.5l-.5.07a4.66,4.66,0,0,0,.4,9.3H22.19a4.61,4.61,0,0,0,4.54-4.66,4.67,4.67,0,0,0-1.85-3.75l-.27-.2.06-.34a7.54,7.54,0,0,0,.09-1.12,6.6,6.6,0,0,0-6.51-6.67A6.5,6.5,0,0,0,12.62,4.46Z"
  }))))))))));
};

export default __webpack_public_path__ + "static/media/download-icon.7b030432.svg";
export { SvgDownloadIcon as ReactComponent };